var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notice"}},[_vm._v("notice")])
}
var staticRenderFns = []

export { render, staticRenderFns }